import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { usePhishPass } from '../../context/PhishPassContext';
import { Loader2 } from 'lucide-react';

const actionBadge = (action) => {
  const map = {
    CREATE: 'bg-emerald-100 text-emerald-700',
    UPDATE: 'bg-blue-100 text-blue-700',
    DELETE: 'bg-red-100 text-red-700',
    SEND_CAMPAIGN: 'bg-amber-100 text-amber-700',
    MARK_TRAINED: 'bg-purple-100 text-purple-700',
    UPDATE_SETTINGS: 'bg-slate-100 text-slate-700',
  };
  return map[action] || 'bg-slate-100 text-slate-600';
};

const PhishPassAuditLogs = () => {
  const { getAuditLogs } = usePhishPass();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => { setLoading(true); setLogs(await getAuditLogs()); setLoading(false); })();
  }, [getAuditLogs]);

  return (
    <div className="space-y-4" data-testid="audit-logs">
      <h2 className="text-lg font-semibold text-slate-900">Audit Logs</h2>
      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
      ) : logs.length === 0 ? (
        <Card><CardContent className="p-8 text-center text-slate-500">No activity logged yet.</CardContent></Card>
      ) : (
        <Card>
          <CardContent className="p-0">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 border-b">
                <tr className="text-left text-xs text-slate-500 uppercase">
                  <th className="px-4 py-3">Timestamp</th>
                  <th className="px-4 py-3">User</th>
                  <th className="px-4 py-3">Action</th>
                  <th className="px-4 py-3">Entity</th>
                  <th className="px-4 py-3">Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(l => (
                  <tr key={l.id} className="border-b hover:bg-slate-50">
                    <td className="px-4 py-3 text-xs text-slate-500">{l.timestamp?.slice(0, 19).replace('T', ' ')}</td>
                    <td className="px-4 py-3">{l.user}</td>
                    <td className="px-4 py-3"><Badge className={actionBadge(l.action)}>{l.action}</Badge></td>
                    <td className="px-4 py-3 text-xs text-slate-600">{l.entity_type}</td>
                    <td className="px-4 py-3 text-xs text-slate-700">{l.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default PhishPassAuditLogs;
